import styled from 'styled-components'

import { textStyles } from '../../theme'
import ActionButton from '../../components/ActionButton'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  flex-grow: 1;
  padding: 2rem;
`

export const Title = styled.p`
  ${textStyles.titleH1}
`

export const Cta = styled(ActionButton)`
  margin-top: 3rem;
  width: auto;
`
